
import Provider from '@/services/provider'
import gtm from '~/mixins/gtm.js'
import hotmartApp from '~/components/Templates/HotmartApp/HotmartApp.vue'

export default {
  mixins: [gtm],
  nuxtI18n: {
    parsePages: true,
    locales: ['pt-br', 'en', 'es', 'es-co', 'es-mx', 'es-es'],
  },
  components: {
    hotmartApp,
  },

  data() {
    return {
      // GTM
      gtmSubsection: 'Hotmart App',
      gtmSubsection2: '',
      // SEO
      title: this.$t('seo.hotmartApp.title'),
      description: this.$t('seo.hotmartApp.description'),
      url: `${process.env.BASE_URL}${this.$route.path}`,
      locale: this.$i18n.locales.find(l => l.code === this.$i18n.locale).iso,
      routeName: this.$route.name,
      orgSchema: { description: this.$t('seo.hotmartApp.description'), ...this.$t('seo.organization') },
    }
  },

  head() {
    const basePayload = {
      title: this.title,
      description: this.description,
      url: this.url,
      locale: this.locale,
      routeName: this.routeName,
    }

    return {
      ...Provider.head.useComposeHeadTag({
        ...basePayload,
        schema: [
          { ...Provider.head.setSchemaOrganization({ ...this.orgSchema }) },
          { ...Provider.head.setSchemaWebpage({ ...basePayload }) },
          { ...Provider.head.setSchemaBreadcrumb({ breadcrumbs: this.breadcrumbs }) },
        ],
        meta: {},
        script: [],
        link: [],
      }),
    }
  },

  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },
}
